import React, { createContext, useState, useEffect, useRef } from "react";
import api from "../../api/api"; // Импорт API клиента

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    navbarColor: "#FFFFFF",
    sidebarColor: "#f5f5f5", // Светло-серый цвет вместо белого
  });
  const requestVersion = useRef(0);
  const fetchTheme = async () => {
    const version = ++requestVersion.current;
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return;
      }

      // Сначала пытаемся загрузить индивидуальные настройки темы пользователя
      try {
        const userThemeResponse = await api.get("/user-theme/theme", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (version !== requestVersion.current) return;
        const { navbar_color, sidebar_color } = userThemeResponse.data;
        setTheme({
          navbarColor: navbar_color,
          sidebarColor: sidebar_color,
        });

        return; // Успешно загрузили индивидуальную тему
      } catch {
        if (version !== requestVersion.current) return;
      }

      // Fallback: загружаем тему из общих настроек бизнеса
      const profileResponse = await api.get("/settings/settings", {
        headers: { Authorization: `Bearer ${token}` },
      });


      if (version !== requestVersion.current) return;
      const { navbar_color, sidebar_color } = profileResponse.data;
      setTheme({ navbarColor: navbar_color, sidebarColor: sidebar_color });

    } catch {
      // Keep the existing theme if both settings endpoints are unavailable.
    }
  };

  useEffect(() => {
    fetchTheme(); // Загружаем тему при первом запуске
    return () => { requestVersion.current += 1; };
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, fetchTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
